"use strict";

(function ($) {
  // ECMA5 strict mode
  'use strict';

  $.b2b = $.b2b || {};
  var defaultOptions = {};
  var storageService = function storageService() {
    var options;
    var me;
    this.addHandler = function (handler) {
      me.handlers.push(handler);
    };
    this.isAvailable = function () {
      if (Modernizr !== undefined && Modernizr !== null) {
        return Modernizr.localstorage;
      }
      return false;
    };
    this.getValue = function (key) {
      var item = '';
      if (this.isAvailable()) {
        item = localStorage.getItem("B2bCart", key);
        if (item === undefined || item === null) {
          item = '';
        }
      }
      return item;
    };
    this.setValue = function (key, value) {
      if (this.isAvailable()) {
        localStorage.setItem("B2bCart", value);
      }
    };
    function handleStorage(e) {
      if (!e) {
        e = window.event;
      }
      for (var i = 0; i < me.handlers.length; i++) {
        var fnc = me.handlers[i];
        if (fnc !== undefined && fnc !== null) {
          me.handlers[i](e);
        }
      }
    }
    this.init = function (opt) {
      options = $.extend({}, defaultOptions, opt);
      me = {
        handlers: []
      };
      if (window.addEventListener) {
        window.addEventListener("storage", handleStorage, false);
      } else {
        window.attachEvent("onstorage", handleStorage);
      }
      ;
    };
    this.init();
  };
  $.b2b.storageService = new storageService();
})(jQuery);